import React from 'react'
import { Row, Col } from 'antd'
import { Classification } from '../../../../../components/Classification'
import { Label, TestingCenter } from '../../../../../components/TestAndLabelLinks'
import { useTranslation } from 'react-i18next'
const LaserClassVerdict = (props) => {
    const { Class } = props.laserClass
    const { t, i18n } = useTranslation();
    var spanBlock = {
        display: "block"
    }
    return (
        <>
            <Row justify={"space-evenly"} align={"middle"}>
                <Col>
                    <div style={{ disaply: "flex", justifySelf: "center", alignSelf: "center", height: "100%", padding: "5px", border: "4px solid #1d1f8c", borderRadius: "15px", display: 'flex', textAlign: "center", justifyContent: "center", alignItems: 'center' }}>
                        {i18n.language ==="de" ? (
                        <strong style={{ fontSize: '20px', color: "#1d1f8c" }}><span style={spanBlock}>Dieses Produkt ist als </span>Laserlasse {Class || props?.laserClass} klassifiziert</strong>
                        ):
                        <strong style={{ fontSize: '20px', color: "#1d1f8c" }}><span style={spanBlock}>THIS PRODUCT IS CLASSIFIED AS A </span>CLASS {Class || props?.laserClass} LASER</strong>   

                        }
                    </div>
                </Col>
                <Col>
                    <Classification Class={Class || props?.laserClass} spanBlock={spanBlock} />
                </Col>
            </Row>
            <Row justify={"center"} style={{ marginTop: "20px" }}>
                <Label />
            </Row>
            <Row justify={"center"} style={{ marginTop: "20px" }}>
                <TestingCenter />
            </Row>
        </>
    )
}

export default LaserClassVerdict